/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  DictionaryDTO,
  GetCampaignClassesParams,
  GetCampaignObjectivesParams,
  GetTouchpointContentTypesParams,
  HtmlContentStatusDto,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getDictionary = () => {
  /**
 * Returns all touchpoint version statuses with their client review and version status display names.

Required: authenticated user
 * @summary Get touchpoint version statuses
 */
  const getVersionStatuses = () => {
    return customInstance<HtmlContentStatusDto[]>({
      url: `/api/dictionary/touchpoint-version-statuses`,
      method: "GET",
    });
  };
  /**
 * Returns touchpoint content types, optionally filtered by campaign objective type.

Required: authenticated user
 * @summary Get touchpoint content types
 */
  const getTouchpointContentTypes = (params?: GetTouchpointContentTypesParams) => {
    return customInstance<DictionaryDTO[]>({
      url: `/api/dictionary/touchpoint-content-types`,
      method: "GET",
      params,
    });
  };
  /**
 * Returns all available touchpoint batch statuses.

Required: authenticated user
 * @summary Get touchpoint batch statuses
 */
  const getTouchpointBatchStatuses = () => {
    return customInstance<DictionaryDTO[]>({
      url: `/api/dictionary/touchpoint-batch-statuses`,
      method: "GET",
    });
  };
  /**
 * Get all program types

Required: authenticated user
 */
  const getProgramTypes = () => {
    return customInstance<DictionaryDTO[]>({ url: `/api/dictionary/program-types`, method: "GET" });
  };
  /**
 * Get all population types

Required: authenticated user
 */
  const getPopulationTypes = () => {
    return customInstance<DictionaryDTO[]>({
      url: `/api/dictionary/population-types`,
      method: "GET",
    });
  };
  /**
 * Returns campaign class types, optionally filtered by campaign objective type.

Required: authenticated user
 * @summary Get campaign class types
 */
  const getCampaignClasses = (params?: GetCampaignClassesParams) => {
    return customInstance<DictionaryDTO[]>({
      url: `/api/dictionary/class-types`,
      method: "GET",
      params,
    });
  };
  /**
 * Get campaign objective types, optionally filtered by program type

Required: authenticated user
 */
  const getCampaignObjectives = (params?: GetCampaignObjectivesParams) => {
    return customInstance<DictionaryDTO[]>({
      url: `/api/dictionary/campaign-objective-types`,
      method: "GET",
      params,
    });
  };
  /**
 * Get all audience types

Required: authenticated user
 */
  const getAudienceTypes = () => {
    return customInstance<DictionaryDTO[]>({
      url: `/api/dictionary/audience-types`,
      method: "GET",
    });
  };
  return {
    getVersionStatuses,
    getTouchpointContentTypes,
    getTouchpointBatchStatuses,
    getProgramTypes,
    getPopulationTypes,
    getCampaignClasses,
    getCampaignObjectives,
    getAudienceTypes,
  };
};
export type GetVersionStatusesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getDictionary>["getVersionStatuses"]>>
>;
export type GetTouchpointContentTypesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getDictionary>["getTouchpointContentTypes"]>>
>;
export type GetTouchpointBatchStatusesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getDictionary>["getTouchpointBatchStatuses"]>>
>;
export type GetProgramTypesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getDictionary>["getProgramTypes"]>>
>;
export type GetPopulationTypesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getDictionary>["getPopulationTypes"]>>
>;
export type GetCampaignClassesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getDictionary>["getCampaignClasses"]>>
>;
export type GetCampaignObjectivesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getDictionary>["getCampaignObjectives"]>>
>;
export type GetAudienceTypesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getDictionary>["getAudienceTypes"]>>
>;
